/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 768;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'pt';
export const localeOptions = [
  { id: 'pt', name: 'Português', direction: 'ltr' },
];

export const searchPath = '/app/processes';

/*
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const defaultColor = 'light.blue';
export const defaultDirection = 'ltr';
export const themeColorStorageKey = '__theme_color';
export const themeRadiusStorageKey = '__theme_radius';
